module.exports = __webpack_public_path__ + "static/media/venus-2.b8b1abce.jpg";